import { useQuery } from '@apollo/react-hooks';

import { EditorBreadcrumbsQuery } from './EditorBreadcrumbsQuery.experimentalgraphql';
import { handleEditorBreadcrumbsQueryResult } from './handleEditorBreadcrumbsQueryResult';
import type {
	EditorBreadcrumbsQuery as EditorBreadcrumbsQueryType,
	EditorBreadcrumbsQueryVariables,
} from './__types__/EditorBreadcrumbsQuery';

export type BreadcrumbsType = Array<{
	url: string | null;
	title: string;
}>;

export function useEditorBreadcrumbs(
	contentId?: EditorBreadcrumbsQueryVariables['contentId'],
): BreadcrumbsType {
	const { data, error } = useQuery<EditorBreadcrumbsQueryType, EditorBreadcrumbsQueryVariables>(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
		EditorBreadcrumbsQuery,
		{
			variables: {
				contentId: contentId!,
			},
			skip: !contentId, // The template editor does not carry a contentId.
		},
	);

	return handleEditorBreadcrumbsQueryResult(data, error);
}
